import { playerConstants } from './constants';

export const playerInitialize = (token) => ({
  type: playerConstants.INITIALIZE,
  token,
});
